<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z17O55/tc-custom/9781938120589.jpg?1718106146855" alt="This image is the cover for the book Original Watergate Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Original Watergate Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>“5 Held in Plot to Bug Democrats’ Offices”: The legendary articles that exposed a crime, ended a presidency, and changed a nation.</b><br/>  <br/> The <i>Washington Post</i>’s seminal Watergate stories have been gathered together for the first time as an e-book, including a foreword by journalists Bob Woodward and Carl Bernstein assessing the impact of their stories decades later.<br/>  <br/> "5 Held in Plot to Bug Democrats' Offices Here", said the headline at the bottom of page one in the Washington Post on Sunday, June 18, 1972. The story reported that a team of burglars had been arrested inside the offices of the Democratic National Committee in the Watergate office complex in Washington. On assignment, Carl Bernstein and Bob Woodward uncovered a widespread political scandal and cover-up at the highest levels of government, culminating with the resignation of President Richard Nixon. The Post won a Pulitzer Prize for its work, which became the subject of two bestselling books and a renowned movie, <i>All the President's Men</i>.<br/>  <br/> This eBook is a look back at the dramatic chain of events that would convulse Washington for two years and lead to the first resignation of a U.S. president, forever changing American politics.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Washington Post, Bob Woodward, Carl Bernstein
      </h2>
      
      <p class="authorDescription body article">Bob Woodward is an associate editor at "The Washington Post", where he has worked for forty-four years. He has shared in two Pulitzer Prizes, first for "The Washington Post" s coverage of the Watergate scandal, and later for coverage of the 9/11 terrorist attacks. He has authored or coauthored twelve #1 national nonfiction bestsellers. He has two daughters, Tali and Diana, and lives in Washington, DC, with his wife, writer Elsa Walsh.Carl Bernstein is a contributing editor for "Vanity Fair" magazine and has written for a variety of publications. He is the author of "Loyalties: A Son s Memoir, " and has coauthored "His Holiness: John Paul II" and the "History of Our Time" with Marco Politi, as well as "All the President's Men" and "The Final Days" with Bob Woodward.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b1ae6bc